import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';
import { Options, Select } from '../../components/Select';
import eyeOpen from '../../img/icon/Olho.svg'
import eyeClose from '../../img/icon/Olho Fechado.svg';

import api from '../../services/api';
import './style.css';

import MultiCheckBox, { OptionType, OnSelectFunction } from '../../components/MultiCheckBox';
import { useNavigate } from 'react-router-dom';

export function CredenciadosCadastrar() {
    const [isLoading, setIsLoading] = useState(true);

    // Informações Gerais
    const [nome, setNome] = useState("");
    const [descricao, setDescricao] = useState("");
    const [duracao, setDuracao] = useState(null);
    const [preco, setPreco] = useState(null);
    const [itens, setItens] = useState<OptionType[]>([]);
    const [selectedItens, setSelectedItens] = useState<string[]>([]);
    const [tipoProduto, setTipoProduto] = useState('Produto');
    const tipos = ['Produto', 'Adicional'];

    // Informações de Funções
    const [quantidadeFuncao, setQuantidadeFuncao] = useState(null);

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordStrength, setPasswordStrength] = useState({ strength: '', color: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [chavePix, setChavePix] = useState('');
    const [documento, setDocumento] = useState("");
    const [porcentagem, setPorcentagem] = useState(0);

    const navigate = useNavigate();

    const duracaoPlano = [
        { id: 96, nome: '96 Horas' },
        { id: 72, nome: '72 Horas' },
        { id: 48, nome: '48 Horas' },
        { id: 24, nome: '24 Horas' }
    ];

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, []);

    useEffect(() => {
        const buscarItens = async () => {
            try {
                const response = await api.get('itens/listar');
                const itensData = response.data;
                const options: OptionType[] = [];

                itensData.map((item: any) => {
                    options.push({ value: item.id, name: item.nome, color: 'blue' });
                });

                setItens(options);
            } catch (error) {
                console.error('Erro ao buscar itens', error);
            }
        };

        buscarItens();
    }, []);

    const parseInputValue = (inputValue: string) => {
        const sanitizedValue = inputValue.replace(/[^0-9.,]/g, '');
        const normalizedValue = sanitizedValue.replace(/(\..*)\./g, '$1');
        return normalizedValue;
    };

    const handleSelect: OnSelectFunction = (selectedValues) => {
        console.log('Valores selecionados:', selectedValues);
        setSelectedItens(selectedValues);
    };

    const handleSelectDuracao = (duracaoHoras: any) => {
        setDuracao(duracaoHoras);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const evaluatePasswordStrength = (password: any) => {
        if (!password) return { strength: '', color: '' };

        const length = password.length;
        const hasNumbers = /\d/.test(password);
        const hasUpperCase = /[A-Z]/.test(password);
        const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        if (length > 8 && hasUpperCase && hasNumbers && hasSpecialChars) {
            return { strength: 'Muito forte', color: 'green' };
        } else if (length > 6 && hasUpperCase && hasNumbers) {
            return { strength: 'Forte', color: 'green' };
        } else if (length > 4 && (hasUpperCase || hasNumbers || hasSpecialChars)) {
            return { strength: 'Média', color: 'yellow' };
        } else if (length > 0) {
            return { strength: 'Fraca', color: 'red' };
        }
        return { strength: '', color: '' };
    };

    const handlePasswordChange = (e: { target: { value: any; }; }) => {
        const newPassword = e.target.value;
        setPassword(newPassword);
        const strength = evaluatePasswordStrength(newPassword);
        setPasswordStrength(strength);
    };

    const handleSubmit = async (event: any) => {
        event.preventDefault();

        let isValid = true;

        if (!nome) {
            setAlert({ message: 'Por favor, preencha o campo Nome', variant: 'danger', show: true });
            isValid = false;
            return
        }
        if (!email) {
            setAlert({ message: 'Por favor, preencha o campo E-mail.', variant: 'danger', show: true });
            isValid = false;
            return
        }
        if (!documento) {
            setAlert({ message: 'Por favor, preencha o campo Documento!', variant: 'danger', show: true });
            isValid = false;
            return
        }
        if (!chavePix) {
            setAlert({ message: 'Por favor, preencha o campo Chave Pix.', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (!password || !confirmPassword) {
            setAlert({ message: 'Por favor, preencha os campos de senha', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (passwordStrength.strength === 'Fraca') {
            setAlert({ message: 'A senha é muito fraca. Por favor, escolha uma senha mais forte.', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (password !== confirmPassword) {
            setAlert({ message: 'As senhas não estão iguais.', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (!porcentagem) {
            setAlert({ message: 'Por favor, preencha o campo Porcentagem (Comissão)', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (isValid) {
            try {
                setIsLoading(true)
                const payload = {
                    nome: nome,
                    email: email,
                    documento: documento,
                    password: password,
                    chave_pix: chavePix,
                    porcentagem_comissao: porcentagem
                };
                const response = await api.post('register/credenciado', payload);

                if (response.data.data === 'Já existe um usuário cadastrado com o e-mail fornecido') {
                    setIsLoading(false)
                    setAlert({ message: 'E-MAIL já cadastrado!', variant: 'danger', show: true });
                    return;
                }

                if (response.status == 200) {
                    setIsLoading(false);
                    setNome('');
                    setDescricao('');
                    setPreco(null);
                    setQuantidadeFuncao(null);
                    setEmail('');
                    setPassword('');
                    setConfirmPassword('');
                    setAlert({ message: 'Credenciado cadastrado com sucesso!', variant: 'success', show: true });
                    navigate('/credenciados');
                }
            } catch (error) {
                console.error('Erro ao enviar dados do formulário:', error);
                setAlert({ message: 'Erro ao enviar dados do formulário', variant: 'danger', show: true });
                setIsLoading(false)
            } finally {
                setIsLoading(false)
            }
        }
    };

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Cadastro de Credenciado</h3>
                    <Row>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Nome do Credenciado *' htmlFor="senha" />
                                <input
                                    type="text"
                                    id="nome"
                                    placeholder="Digite o Nome do Credenciado"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='E-mail do Credenciado *' htmlFor="senha" />
                                <input
                                    type="text"
                                    id="email"
                                    placeholder="Digite o e-mail do Credenciado"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Documento do Credenciado *' htmlFor="senha" />
                                <InputMask
                                    type="text"
                                    id="cpf_cnpj"
                                    placeholder="Digite o CNPJ ou CPF do Credenciado"
                                    value={documento}
                                    onChange={(e: any) => setDocumento(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Chave PIX *' htmlFor="senha" />
                                <InputMask
                                    type="text"
                                    id="cpf_cnpj"
                                    placeholder="Digite a chave PIX"
                                    value={chavePix}
                                    onChange={(e: any) => setChavePix(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={5} xl={5}>
                            <FormGroup>
                                <Label title='Senha *' htmlFor="senha" />
                                <input
                                    className={`form-control password-input ${passwordStrength.color}`}
                                    type={showPassword ? "text" : "password"}
                                    id="senha"
                                    placeholder="Digite a senha"
                                    value={password}
                                    onChange={handlePasswordChange}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={5} xl={5}>
                            <FormGroup>
                                <Label title='Confirmar Senha *' htmlFor="confirmSenha" />
                                <input
                                    className={`form-control ${password && confirmPassword && password === confirmPassword ? 'is-valid' : confirmPassword && 'is-invalid'}`}
                                    type={showPassword ? "text" : "password"}
                                    id="confirmSenha"
                                    placeholder="Confirme sua senha"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={2} xl={2}>
                            <FormGroup>
                                <Label title='Porcentagem (Comissão) *' htmlFor="porcentagem" />
                                <InputMask
                                    type="number"
                                    id="porcentagem"
                                    placeholder="Digite a a porcentagem de comissão"
                                    value={porcentagem}
                                    onChange={(e: any) => setPorcentagem(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <div className={`${passwordStrength.color}`} style={{ fontSize: '15px', marginLeft: '8px' }}>{passwordStrength.strength}</div>
                    </Row>
                    <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                        <Button type="submit" style={{ width: '10%' }} className="saveButton" onClick={handleSubmit}>Salvar</Button>
                    </Row>

                </Form>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
